var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgToken = function SvgToken(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "token")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "token",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.000000, 22.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 5.5,
    x2: 16,
    y2: 3.5,
    id: "Line-6",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.25,
    y1: 18,
    x2: 5.75,
    y2: 16,
    id: "Line-6",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.2153889,
    y1: 10.9609699,
    x2: 2.7153889,
    y2: 8.96096995,
    id: "Line-6",
    strokeLinecap: "square",
    transform: "translate(1.965389, 9.960970) rotate(53.000000) translate(-1.965389, -9.960970) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.1504538,
    y1: 11.1996589,
    x2: 18.6504538,
    y2: 9.19965888,
    id: "Line-6",
    strokeLinecap: "square",
    transform: "translate(17.900454, 10.199659) rotate(53.000000) translate(-17.900454, -10.199659) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.79180857,
    y1: 4.59704626,
    x2: 5.29180857,
    y2: 2.59704626,
    id: "Line-6",
    strokeLinecap: "square",
    transform: "translate(4.541809, 3.597046) rotate(-77.000000) translate(-4.541809, -3.597046) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.0562378,
    y1: 17.7564075,
    x2: 15.5562378,
    y2: 15.7564075,
    id: "Line-6",
    strokeLinecap: "square",
    transform: "translate(14.806238, 16.756407) rotate(-77.000000) translate(-14.806238, -16.756407) "
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToken, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/token.43e86a37.svg";
export { ForwardRef as ReactComponent };